/* eslint-disable prettier/prettier */
import Viewer from "bpmn-js/lib/NavigatedViewer";
import React, { useState, useEffect, useRef, useCallback } from "react";

const BPMNDiagram = ({ xml, markers, style, children, ParentChange }) => {
  const [loaded, setLoaded] = useState(false);
  const containerRef = useRef(null);
  const viewerRef = useRef(null);

  const getHighlightColor = useCallback((activity) => {
    return activity.hasIncident
      ? "highlightincident"
      : activity.isExpired
        ? "highlightexpired"
        : activity.finished
          ? "highlightlast"
          : "highlight";
  }, []);

  const handleDocumentChange = useCallback((element) => {
    ParentChange && ParentChange(element);
  }, [ParentChange]);

  const importXML = useCallback((xmlContent, markersContent) => {
    if (!viewerRef.current) return;

    viewerRef.current.importXML(xmlContent).then((result) => {
      const canvas = viewerRef.current.get("canvas");
      canvas.zoom("fit-viewport", "auto");
      canvas.resized();

      if (markersContent && markersContent.length > 0) {
        const activityMarkers = {};
        for (let idx = 0; idx < markersContent.length; idx++) {
          activityMarkers[markersContent[idx].activityId] = {
            activity: markersContent[idx].activityId,
            color: getHighlightColor(markersContent[idx]),
          };
        }

        const activityKeys = Object.keys(activityMarkers);
        for (let idx = 0; idx < activityKeys.length; idx++) {
          canvas.addMarker(
            activityMarkers[activityKeys[idx]].activity,
            activityMarkers[activityKeys[idx]].color,
          );
        }
      }

      setLoaded(true);
    });
  }, [getHighlightColor]);

  useEffect(() => {
    if (!viewerRef.current) {
      viewerRef.current = new Viewer({
        canvas: {
          deferUpdate: true,
        },
      });
    }

    if (containerRef.current) {
      viewerRef.current.attachTo(containerRef.current);
      importXML(xml, markers);

      viewerRef.current.on("selection.changed", (e) => {
        handleDocumentChange(e.newSelection[0]);
      });

      viewerRef.current.on("element.changed", (e) => {
        handleDocumentChange(e.element);
      });
    }
  }, [importXML, handleDocumentChange, xml, markers]);

  useEffect(() => {
    if (xml && viewerRef.current) {
      setLoaded(false);
      importXML(xml, markers);
    }
  }, [xml, markers, importXML]);

  return (
    <div className="BPMNDiagram" style={style} ref={containerRef}>
      {loaded &&
        children &&
        React.cloneElement(children, { viewer: viewerRef.current })}
    </div>
  );
};

export default BPMNDiagram;
